import { useCallback, useEffect, useState } from "react";

const useKeyPress = (targetKey: string): boolean => {
  const [isKeyPress, setIsKeyPress] = useState(false);

  const handleKeyDown = useCallback(
    (event: KeyboardEvent) => {
      const { key } = event;
      setIsKeyPress(key === targetKey);
    },
    [targetKey],
  );

  const handleKeyUp = useCallback(() => {
    setIsKeyPress(false);
  }, []);

  useEffect(() => {
    window.addEventListener("keydown", handleKeyDown);
    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [handleKeyDown]);

  useEffect(() => {
    window.addEventListener("keyup", handleKeyUp);
    return () => {
      window.removeEventListener("keyup", handleKeyUp);
    };
  }, [handleKeyUp]);

  return isKeyPress;
};

export default useKeyPress;
